export default __webpack_public_path__ + "static/media/wfn-app-logo.fb41a709.svg";